// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__xDVQI","content":"styles_content__zsPte","selectAll":"styles_selectAll__HPK3A"};